import { render, staticRenderFns } from "./UserPersonalDetails.vue?vue&type=template&id=3bd88d92&scoped=true"
import script from "./UserPersonalDetails.vue?vue&type=script&lang=js"
export * from "./UserPersonalDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd88d92",
  null
  
)

export default component.exports